module.exports = __webpack_public_path__ + "static/media/PC4-3-2.07ca74a0.jpg";